import { IReportType } from '@app/models/report-type';
import { IVersion } from '../../models/version';

export interface State {
    progress: any;
    reports: IReportType[];
    versions: IVersion[];
}

export const initializeReportState = (): State => {
    return {
        progress: {},
        versions: [],
        reports: []
    };
};
